import { Routes } from '@angular/router';

import { authBootstrapGuard } from 'app/shared/guards';

export const routes: Routes = [
    { path: '', pathMatch: 'full', loadComponent: () => import('@venecia/pages').then(m => m.Landing) },
    { path: 'oauth', loadComponent: () => import('@venecia/pages').then(m => m.OAuthPage) },
    {
        path: '',
        loadComponent: () => import('@venecia/templates').then(m => m.ShellLayout),
        canActivate: [authBootstrapGuard],
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
            { path: 'dashboard', loadComponent: () => import('@venecia/pages').then(m => m.Dashboard) },
            { path: 'accounts/:id', loadComponent: () => import('@venecia/pages').then(m => m.AccountDetail) },
            { path: 'accounts', loadComponent: () => import('@venecia/pages').then(m => m.Accounts) },
            { path: 'applications/:id', loadComponent: () => import('@venecia/pages').then(m => m.ApplicationDetail) },
            { path: 'applications', loadComponent: () => import('@venecia/pages').then(m => m.Applications) },
            { path: 'licenses', loadComponent: () => import('@venecia/pages').then(m => m.Licenses) },
            { path: 'profiles', loadComponent: () => import('@venecia/pages').then(m => m.Profiles) },
            { path: 'roles', loadComponent: () => import('@venecia/pages').then(m => m.Roles) },
            { path: 'users', loadComponent: () => import('@venecia/pages').then(m => m.Users) },
            { path: 'clients', loadComponent: () => import('@venecia/pages').then(m => m.Clients) },
            { path: 'profile', loadComponent: () => import('@venecia/pages').then(m => m.UserProfile) },
            { path: '**', redirectTo: 'dashboard' },
        ],
    },    
    { path: '**', redirectTo: '' },
];
